module.exports = __webpack_public_path__ + "img/banner afbeelding studiegids.b53965d6.jpg";